import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './PostLogShareSelector.module.css';
import Button from 'components/UI/Button/Button';
import Modal from 'components/UI/Modal/Modal';

const PostLogShareSelector = (props) => {
  const logList = props.logs.map((log) => (
    <div className={classes.Log} key={log.Id} onClick={() => props.handleLogSelect(log.Id)}>
      {log.Name}
      {props.selectedLogs.includes(log.Id) === true ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}
    </div>
  ));
  return (
    <Modal className="LogsSharer" close={props.close} closeOnOutsideClick show={props.show}>
      <div className={classes.LogShareContainer}>
        <div className={classes.Header}>
          <span className={classes.Cancel} onClick={props.close}>
            CANCEL
          </span>
          <h2>Logs</h2>
          <Button className btnType="SavePost" disabled={false} clicked={props.handlePostLogsUpdate}>
            SAVE
          </Button>
        </div>
        <p className={classes.SubTitle}>Select log(s) for this post</p>
        <div className={classes.LogsListItemContainer}>{logList}</div>
      </div>
    </Modal>
  );
};

export default PostLogShareSelector;
